import {Button, Group, Input, Label, NumberField, Radio, RadioGroup} from 'react-aria-components'

import {
  isFoodSupportedCountry,
  TIPS_NUMBER_FORMAT_OPTIONS,
  TIPS_PRESET,
} from '@/lib/food-grubhub/config'
import {useTips} from '@/lib/food-grubhub/store'
import {useCountry} from '@/lib/locale/country'

import style from './FoodTips.module.scss'

export default memo(function FoodTips() {
  const [country] = useCountry()

  invariant(isFoodSupportedCountry(country), 'Country is not supported')

  const [tips, setTips] = useTips()

  const numberFormatter = Intl.NumberFormat('en-US', TIPS_NUMBER_FORMAT_OPTIONS[country])

  const handleTipsChange = useCallback(
    (value: string) => {
      if (value === 'custom') {
        setTips({
          type: 'custom',
          data: 0,
        })
        return
      }

      setTips({
        type: 'preset',
        data: parseInt(value),
      })
    },
    [setTips],
  )

  return (
    <div>
      <RadioGroup
        className={style.TipsRadioGroup}
        defaultValue={tips.type === 'preset' ? tips.data.toString() : 'custom'}
        onChange={handleTipsChange}
      >
        <Label className={style.TipsRadioGroupLabel}>Tips for your driver</Label>
        <div className={style.TipsRadioGroupRadioGroup}>
          {Object.entries(TIPS_PRESET[country]).map(([key, value]) => (
            <Radio key={key} value={key} className={style.TipsRadioGroupRadio}>
              {numberFormatter.format(value)}
            </Radio>
          ))}
          <Radio value={'custom'} className={style.TipsRadioGroupRadio}>
            Custom
          </Radio>
        </div>
      </RadioGroup>
      {tips.type === 'custom' && (
        <NumberField
          className={style.TipsCustom}
          minValue={0}
          formatOptions={TIPS_NUMBER_FORMAT_OPTIONS[country]}
          onChange={value => {
            setTips({
              type: 'custom',
              data: value,
            })
          }}
          value={tips.data}
        >
          <Label className='strict-visually-hidden'>Custom tips for your driver</Label>
          <Group className={style.TipsCustomGroup}>
            <Button slot='decrement' className={style.TipsCustomButton}>
              -
            </Button>
            <Input className={style.TipsCustomInput} />
            <Button slot='increment' className={style.TipsCustomButton}>
              +
            </Button>
          </Group>
        </NumberField>
      )}
    </div>
  )
})
